import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=229815e8&scoped=true&"
import script from "./Country.vue?vue&type=script&lang=js&"
export * from "./Country.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229815e8",
  null
  
)

export default component.exports